import { buildBreadcrumbNavigationConfig } from "../shared/helpers/buildBreadcrumbNavigationConfig";
import { ParticipantFAQPage } from "./pages/participantFAQPage";
import { ParticipantFinancesPage } from "./pages/participantFinancesPage";
import { Glossary } from "./pages/participantGlossaryPage";
import { HelpCenter } from "./pages/participantHelpCenterPage";
import { ParticipantSettingsPage } from "./pages/participantSettingsPage";
import { ParticipantStripePage } from "./pages/participantStripePage";

const participantStripePagePath = "/dashboard";
const participantSettingsPagePath = "/settings";
const participantFinancesPagePath = "/finances";
const participantFAQPagePath = "/faq";
const participantGlossaryPath = "/glossary";
const participantHelpCenterPath = "/help";

const participantSettingsPageNav = buildBreadcrumbNavigationConfig(
  "Settings",
  participantSettingsPagePath
);

const participantFinancesPageNav = buildBreadcrumbNavigationConfig(
  "My Finances",
  participantFinancesPagePath
);

const participantFAQPageNav = buildBreadcrumbNavigationConfig(
  "FAQ",
  participantFAQPagePath
);

const participantGlossaryNav = buildBreadcrumbNavigationConfig(
  "Glossary",
  participantGlossaryPath
);

const participantHelpPageNav = buildBreadcrumbNavigationConfig(
  "Help",
  participantHelpCenterPath
);

export const routes = [
  {
    path: participantStripePagePath,
    Component: ParticipantStripePage,
    exact: true,
    isPrivate: true,
  },
  {
    path: participantSettingsPagePath,
    Component: ParticipantSettingsPage,
    exact: true,
    isPrivate: true,
    navigation: [participantSettingsPageNav],
  },
  {
    path: participantFinancesPagePath,
    Component: ParticipantFinancesPage,
    exact: true,
    isPrivate: true,
    navigation: [participantFinancesPageNav],
  },
  {
    path: participantFAQPagePath,
    Component: ParticipantFAQPage,
    exact: true,
    isPrivate: true,
    isDisplayed: true,
    hasAccess: true,
    navigation: [participantFAQPageNav],
  },
  {
    path: participantGlossaryPath,
    Component: Glossary,
    exact: true,
    isPrivate: true,
    navigation: [participantGlossaryNav],
  },
  {
    path: participantHelpCenterPath,
    Component: HelpCenter,
    exact: true,
    isPrivate: true,
    navigation: [participantHelpPageNav],
  },
];

export const routesLimited = [participantFinancesPagePath];
